module.exports = __webpack_public_path__ + "static/media/LockMenu1.6300663c.png";